/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteAssetMapAssetResponseDto
 */
export interface SiteAssetMapAssetResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SiteAssetMapAssetResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SiteAssetMapAssetResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof SiteAssetMapAssetResponseDto
     */
    assetTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof SiteAssetMapAssetResponseDto
     */
    assetModelName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiteAssetMapAssetResponseDto
     */
    zoneName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SiteAssetMapAssetResponseDto
     */
    installedAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SiteAssetMapAssetResponseDto
     */
    openIncidentsCount: number;
}

/**
 * Check if a given object implements the SiteAssetMapAssetResponseDto interface.
 */
export function instanceOfSiteAssetMapAssetResponseDto(value: object): value is SiteAssetMapAssetResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('assetTypeName' in value) || value['assetTypeName'] === undefined) return false;
    if (!('assetModelName' in value) || value['assetModelName'] === undefined) return false;
    if (!('zoneName' in value) || value['zoneName'] === undefined) return false;
    if (!('installedAt' in value) || value['installedAt'] === undefined) return false;
    if (!('openIncidentsCount' in value) || value['openIncidentsCount'] === undefined) return false;
    return true;
}

export function SiteAssetMapAssetResponseDtoFromJSON(json: any): SiteAssetMapAssetResponseDto {
    return SiteAssetMapAssetResponseDtoFromJSONTyped(json, false);
}

export function SiteAssetMapAssetResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteAssetMapAssetResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetName': json['assetName'],
        'assetTypeName': json['assetTypeName'],
        'assetModelName': json['assetModelName'],
        'zoneName': json['zoneName'],
        'installedAt': (json['installedAt'] == null ? null : new Date(json['installedAt'])),
        'openIncidentsCount': json['openIncidentsCount'],
    };
}

export function SiteAssetMapAssetResponseDtoToJSON(json: any): SiteAssetMapAssetResponseDto {
    return SiteAssetMapAssetResponseDtoToJSONTyped(json, false);
}

export function SiteAssetMapAssetResponseDtoToJSONTyped(value?: SiteAssetMapAssetResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetName': value['assetName'],
        'assetTypeName': value['assetTypeName'],
        'assetModelName': value['assetModelName'],
        'zoneName': value['zoneName'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'openIncidentsCount': value['openIncidentsCount'],
    };
}

